/** Firebase / Emulator 用の環境変数ゲート（ハードコードの localhost フォールバック禁止） */

export function useFirebaseEmulator(): boolean {
  return process.env.VUE_APP_USE_FIREBASE_EMULATOR === 'true'
}

export function requireProcessEnv(name: string): string {
  const value = process.env[name]
  if (value == null || value === '') {
    throw new Error(`[firebase] missing required env: ${name}`)
  }
  return value
}

function isLoopbackAuthDomain(authDomain: string): boolean {
  const host = authDomain.split('/')[0].toLowerCase()
  return (
    host === 'localhost' ||
    host.startsWith('localhost:') ||
    host === '127.0.0.1' ||
    host.startsWith('127.0.0.1:')
  )
}

/**
 * staging / production 系で authDomain が loopback、または Emulator フラグが混入していたら即失敗。
 * Vue CLI はビルド時に env を埋め込むため、誤 mode / 誤 .env のままデプロイする事故を起動時に潰す。
 */
export function assertFirebaseAuthDomainSafe(authDomain: string): void {
  const mode = process.env.VUE_APP_MODE || ''
  const deployedModes = new Set([
    'staging',
    'staging-oem',
    'staging-beauty',
    'production',
    'production-temp'
  ])

  if (!deployedModes.has(mode)) return

  if (useFirebaseEmulator()) {
    throw new Error(
      `[firebase] VUE_APP_USE_FIREBASE_EMULATOR=true must not be set for VUE_APP_MODE=${mode}`
    )
  }

  if (isLoopbackAuthDomain(authDomain)) {
    throw new Error(
      `[firebase] VUE_APP_FIREBASE_AUTHDOMAIN must not be localhost/127.0.0.1 for VUE_APP_MODE=${mode} (got ${authDomain}). Use the mode's .env (e.g. .env.staging).`
    )
  }
}
